module.exports = __webpack_public_path__ + "portal/static/img/tmb.d7aac12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/tmb.png
// module id = AAjM
// module chunks = 67